import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=183f5346&scoped=true";
import script from "./Join.vue?vue&type=script&lang=js";
export * from "./Join.vue?vue&type=script&lang=js";
import style0 from "./Join.vue?vue&type=style&index=0&id=183f5346&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "183f5346", null);
export default component.exports;